module.exports = __webpack_public_path__ + "static/media/S3N10.2b832a33.svg";